import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import { SideNav } from './SideNav';
import { TopBar } from './TopBar';
import { osirisTokens } from '@/theme/tokens';

export function AppShell() {
  return (
    <Box
      className="app-shell"
      sx={{
        display: 'grid',
        gridTemplateAreas: `
          "sidenav topbar"
          "sidenav content"
        `,
        gridTemplateColumns: `${osirisTokens.layout.sidebarWidth}px 1fr`,
        gridTemplateRows: `${osirisTokens.layout.headerHeight}px 1fr`,
        height: '100vh',
        width: '100vw',
        bgcolor: osirisTokens.bg.page,
        color: osirisTokens.text.primary,
        overflow: 'hidden',
      }}
    >
      <SideNav />
      <TopBar />

      <Box
        component="main"
        className="app-shell-content"
        sx={{
          gridArea: 'content',
          overflow: 'auto',
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
